import axiosInstance from "./axiosInstance";

export const getEUMRVData = async (vesselId, benchmarkYear) => {
  const res = await axiosInstance.post(`/compliance/eumrv/${vesselId}?benchmarkYear=${benchmarkYear}`)
  return res.data;
};

export const getEUETSData = async (vesselId, benchmarkYear) => {
  const res = await axiosInstance.post(`/compliance/euets/${vesselId}?year=${benchmarkYear}`)
  return res.data;
};

export const getCIIData = async (vesselId, benchmarkYear) => {
  const res = await axiosInstance.post(
    `/compliance/${vesselId}/ciidata?benchmarkYear=${benchmarkYear}`
  );
  return res.data;
};


export const getFuelEUData = async (vesselId, benchmarkYear) => {
  const res = await axiosInstance.post(`/compliance/fueleu/${vesselId}?benchmarkYear=${benchmarkYear}`)
  return res.data;
};

export const getUKMRVData = async (vesselId, benchmarkYear) => {
  const res = await axiosInstance.post(`/compliance/${vesselId}/ukmrv?benchmarkYear=${benchmarkYear}`)
  return res.data;
};

export const getIMODCSData = async (vesselId, benchmarkYear) => {
  const res = await axiosInstance.post(`/compliance/imodcs/${vesselId}?benchmarkYear=${benchmarkYear}`)
  return res.data;
};

export const getAvailableYear = async () => {
  const res = await axiosInstance.post(`/compliance/getavailableyears`);
  return res.data;
};

export const getReportTypes = async () => {
  const res = await axiosInstance.post(`/compliance/report-types`);
  return res.data;
};

// export const getTemplate = async (templateId, year, vesselId) => {
//   const res = await axiosInstance.post(`/compliance/download/${vesselId}/${templateId}?year=${year}`);
// }
export const getTemplate = async (templateId, year, vesselId) => {
  const res = await axiosInstance.post(
    `/compliance/download/${vesselId}/${templateId}?year=${year}`,
    {},
    {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      }
    }
  );
  return res;
};
